import { subaward as constants } from "store/constants";
import { reduceIsFetching, fetchableInitialState } from "store/factories/fetchable";


const initialState = {
	content: {
		subaward: {
			...fetchableInitialState,
		},
		values: {
			...fetchableInitialState,
			data: {},
		},
	},
};

export function subaward (state = initialState, action) {
	switch (action.type) {
	case constants.SINGLE_SUBAWARD_IS_FETCHING:
		return {
			...state,
			content: {
				...state.content,
				subaward: reduceIsFetching(state.content.subaward, action),
			},
		};
	case constants.SINGLE_SUBAWARD_SET_ERROR:
		return {
			...state,
			content: {
				subaward: {
					...state.content.subaward,
					error: action.payload,
				},
			},
		};
	case constants.SINGLE_SUBAWARD_SET_DATA:
		return {
			...state,
			content: {
				...state.content,
				...action.payload,
			},
		};

	case constants.SINGLE_SUBAWARD_VALUES_IS_FETCHING:
		return {
			...state,
			content: {
				...state.content,
				values: reduceIsFetching(state.content.values, action),
			},
		};
	case constants.SINGLE_SUBAWARD_VALUES_SET_ERROR:
		return {
			...state,
			content: {
				...state.content,
				values: {
					...state.content.values,
					error: action.payload,
				},
			},
		};
	case constants.SINGLE_SUBAWARD_VALUES_SET_DATA:
		return {
			...state,
			content: {
				...state.content,
				values: {
					...state.content.values,
					data: action.payload,
				},
			},
		};
	case constants.RESET:
		return initialState;
	default:
		return state;
	}
}
